import axios from 'axios'

const API_BASE_URL = import.meta.env?.VITE_API_URL || 'http://localhost:8080'

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// API methods
export const api = {
  // Auth
  login: (username: string, password: string) => {
    const formData = new FormData()
    formData.append('username', username)
    formData.append('password', password)
    return apiClient.post('/api/v1/auth/login', formData, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  },

  // Orders
  getOrders: (params?: any) => apiClient.get('/api/v1/orders', { params }),
  getOrderDetail: (id: number) => apiClient.get(`/api/v1/orders/${id}`),
  getOrderStats: (days: number = 30) => apiClient.get('/api/v1/orders/stats/summary', { params: { days } }),

  // Distributors
  getDistributors: () => apiClient.get('/api/v1/distributors'),
  getDistributorDetail: (id: number) => apiClient.get(`/api/v1/distributors/${id}`),

  // Maps
  getHeatMapData: (monthYear?: string) => apiClient.get('/api/v1/maps/heat-map', { params: { month_year: monthYear } }),
  getDistributionFlowData: (monthYear?: string) => apiClient.get('/api/v1/maps/distribution-flow', { params: { month_year: monthYear } }),
  getDistributorLocations: () => apiClient.get('/api/v1/maps/distributor-locations'),
  getVolumeByState: (monthYear?: string) => apiClient.get('/api/v1/maps/volume-by-state', { params: { month_year: monthYear } }),

  // Reports
  getSalesSummaryReport: (params?: any) => apiClient.get('/api/v1/reports/sales-summary', { params }),
  getVolumeTrendsReport: (months: number = 6) => apiClient.get('/api/v1/reports/volume-trends', { params: { months } }),

  // Data Import
  uploadCSV: (formData: FormData) => apiClient.post('/api/v1/data-import/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  getImportStats: () => apiClient.get('/api/v1/data-import/import-stats'),
}

export default api
